var _rect, _rect2, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSessionEnded(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 4,
    width: 48,
    height: 48,
    rx: 24,
    fill: "#FEE4E2"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 4,
    width: 48,
    height: 48,
    rx: 24,
    stroke: "#FEF3F2",
    strokeWidth: 8
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.0007 27.9993L24.4399 25.0321C23.9109 24.5912 23.6463 24.3708 23.4562 24.1005C23.2877 23.8611 23.1626 23.594 23.0865 23.3113C23.0007 22.9922 23.0007 22.6478 23.0007 21.9592V19.666M28.0007 27.9993L31.5614 25.0321C32.0904 24.5912 32.355 24.3708 32.5451 24.1005C32.7136 23.8611 32.8387 23.594 32.9148 23.3113C33.0007 22.9922 33.0007 22.6478 33.0007 21.9592V19.666M28.0007 27.9993L24.4399 30.9666C23.9109 31.4075 23.6463 31.6279 23.4562 31.8982C23.2877 32.1376 23.1626 32.4047 23.0865 32.6874C23.0007 33.0065 23.0007 33.3509 23.0007 34.0395V36.3327M28.0007 27.9993L31.5614 30.9666C32.0904 31.4075 32.355 31.6279 32.5451 31.8982C32.7136 32.1376 32.8387 32.4047 32.9148 32.6874C33.0007 33.0065 33.0007 33.3509 33.0007 34.0395V36.3327M21.334 19.666H34.6673M21.334 36.3327H34.6673",
    stroke: "#D92D20",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSessionEnded);
export default __webpack_public_path__ + "static/media/session-ended.772ce3f286ac064cadaab87646214d24.svg";
export { ForwardRef as ReactComponent };